import { Badge, Chip } from '@mui/material';
import React from 'react';

interface CounterProps {
  itemStatus: string
}

const AssetDistributionStatusChip = (props: CounterProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (props.itemStatus === 'CANCELLED') {
    color = 'error'
    variant = 'outlined'
  } else if (props.itemStatus === 'AWAITING_PAYMENT') {
    color = 'warning'
    variant = 'outlined'
  } else if (props.itemStatus === 'PAYMENT_CONFIRMED') {
    color = 'success'
    variant = 'outlined'
  } else if (props.itemStatus === 'TOTALS_CONFIRMED') {
    color = 'secondary'
    variant = 'outlined'
  } else if (props.itemStatus === 'PROCESSED') {
    color = 'primary'
    variant = 'outlined'
  }

  return (
      <Chip label={props.itemStatus} variant={variant} color={color} />
  )
}

export default AssetDistributionStatusChip;
